import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, Form } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";
import { FormField, CustomFormInput, SelectFormField, CheckFormField } from "../../../utils/FormFields";
import Autosuggest from "../../AutosuggestCompliance";
import { PersonType } from "../Account/types";
import { showToast } from "../../../utils/Helper";

const ModalShareHolder = ({
  open,
  onToggle,
  onSave,
  loading,
  initialShareHolder,
  shareHolders,
  personId,
  services,
  Link,
  onboarding,
  peopleRelated,
  userSession,
  headerText,
}) => {
  const [newShareHolder, setNewShareHolder] = useState({
    ShareHolderId: initialShareHolder ? initialShareHolder.ShareHolderId : 0,
    ShareHolderDescription: initialShareHolder ? initialShareHolder.ShareHolderDescription : "",
    ShareHolderParticipationPercentage: initialShareHolder
      ? initialShareHolder.ShareHolderParticipationPercentage
      : 0,
    ShareHolderPersonId: initialShareHolder ? initialShareHolder.ShareHolderPersonId : undefined,
    ShareHolderPersonName: initialShareHolder ? initialShareHolder.ShareHolderPersonName : undefined,
    ShareHolderPersonType: initialShareHolder
      ? initialShareHolder.ShareHolderPersonType
      : PersonType.Physical,
    ShareHolderHasWebAccount: initialShareHolder ? initialShareHolder.ShareHolderHasWebAccount : false,
    ShareHolderIsReadOnly: initialShareHolder ? initialShareHolder.ShareHolderIsReadOnly : false,
  });

  const [personSearch, setPersonSearch] = useState(
    initialShareHolder ? initialShareHolder.ShareHolderPersonName : ""
  );

  const [showError, setShowError] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  const onSuggestionFetchRequested = (value) =>
    new Promise((resolve) => {
      const body = {
        name: value,
        personType: newShareHolder.ShareHolderPersonType,
      };
      services.fetchPersonSuggestion(body, (response) => {
        const suggestions = [];
        if (response && response.suggestions) {
          response.suggestions.map((s) => {
            let exists = false;
            shareHolders.map((sh) => {
              exists = exists || sh.ShareHolderPersonId === s.Id;
              return {};
            });
            if (!exists && s.Id !== personId) {
              suggestions.push({
                id: s.Id,
                name: s.Name,
              });
            }
            return {};
          });
        }
        setSuggestions(suggestions);
        resolve(suggestions);
      });
    });

  const [participation, setParticipation] = useState(false);
  const [hasWebAccount, setHasWebAccount] = useState(false);

  const saveShareHolder = (newShareHolder) => {
    setShowError(false);
    if (validForm(newShareHolder)) {
      onSave(newShareHolder);
    } else {
      setShowError(true);
      showToast("Please fill all required fields", true);
    }
  };

  const validForm = (newShareHolder) => {
    if (
      newShareHolder.ShareHolderPersonType &&
      newShareHolder.ShareHolderPersonId &&
      (!participation || (participation && newShareHolder.ShareHolderParticipationPercentage > 0)) &&
      (!peopleRelated || (peopleRelated && newShareHolder.ShareHolderDescription.trim() !== ""))
    ) {
      return true;
    } else {
      return false;
    }
  };

  const onChangeSuggest = (value) => {
    setPersonSearch(value);
  };

  const onSuggestionSelected = (id, value) => {
    setNewShareHolder({
      ...newShareHolder,
      ShareHolderPersonId: id,
      ShareHolderPersonName: value,
    });
    setPersonSearch(value);
  };

  const onBlurPersonName = () => {
    const found = suggestions.find((s) => s.name === personSearch);
    if (!found) {
      setShowError(true);
      setPersonSearch("");
      setNewShareHolder({
        ...newShareHolder,
        ShareHolderPersonId: undefined,
        ShareHolderPersonName: undefined,
      });
    }
  };

  useEffect(() => {
    if (personSearch && suggestions.length > 0) {
      const found = suggestions.find((s) => s.name === personSearch);
      if (!found) {
        setShowError(true);
        setNewShareHolder({
          ...newShareHolder,
          ShareHolderPersonId: undefined,
          ShareHolderPersonName: undefined,
        });
      } else {
        setShowError(false);
      }
    }
  }, [personSearch, suggestions]);

  const onChange = (name, value) => {
    const shareHolder = {
      ...newShareHolder,
      [name]: value,
    };
    setNewShareHolder(shareHolder);
  };

  const onChangePersonType = (name, value) => {
    const shareHolder = {
      ...newShareHolder,
      [name]: value,
      ShareHolderPersonId: undefined,
      ShareHolderPersonName: undefined,
    };
    setNewShareHolder(shareHolder);
    setPersonSearch("");
  };

  const preCheckPercentage = () => {
    let percentage = 0;
    shareHolders.map((s) => {
      if (s.ShareHolderId !== newShareHolder.ShareHolderId) {
        percentage += parseFloat(s.ShareHolderParticipationPercentage);
      }
      return {};
    });
    return percentage + parseFloat(newShareHolder.ShareHolderParticipationPercentage) > 100;
  };

  useEffect(() => {}, [newShareHolder]);

  return (
    <div>
      <Modal isOpen={open} toggle={onToggle}>
        <ModalHeader toggle={onToggle}>
          {headerText ? headerText : initialShareHolder ? "Edit Share Holder" : "Add New Share Holder"}
        </ModalHeader>
        <ModalBody>
          <Form>
            <SelectFormField
              label="Person Type: "
              name="ShareHolderPersonType"
              value={newShareHolder.ShareHolderPersonType}
              onChange={onChangePersonType}
              selectItems={["Physical", "Juridical"]}
              getSelectItemId={(item) => item}
              getSelectItemName={(item) => item}
            />
            <CustomFormInput
              label="Person Name: "
              error={showError && !newShareHolder.ShareHolderPersonName ? "Required" : ""}
            >
              <Autosuggest
                value={personSearch}
                onSelect={onSuggestionSelected}
                onChange={onChangeSuggest}
                fecthSuggestions={onSuggestionFetchRequested}
                onBlur={onBlurPersonName}
              />
            </CustomFormInput>
            <FormField
              label="Relationship Description: "
              value={newShareHolder.ShareHolderDescription}
              name="ShareHolderDescription"
              onChange={onChange}
            />
            {peopleRelated ? (
              <div>
                <CheckFormField
                  label="Has a participation? "
                  initialValue={participation}
                  value={participation}
                  onChange={(e) => setParticipation(!participation)}
                  name="Participation"
                />
                {participation && (
                  <CustomFormInput
                    label="Participation Percentage"
                    error={
                      showError && newShareHolder.ShareHolderParticipationPercentage === 0 ? "Required" : ""
                    }
                  >
                    <FormField
                      value={newShareHolder.ShareHolderParticipationPercentage}
                      type="numeric"
                      onChange={onChange}
                      name="ShareHolderParticipationPercentage"
                    />
                  </CustomFormInput>
                )}
              </div>
            ) : (
              <CustomFormInput
                label="Participation Percentage"
                error={showError && newShareHolder.ShareHolderParticipationPercentage === 0 ? "Required" : ""}
              >
                <FormField
                  value={newShareHolder.ShareHolderParticipationPercentage}
                  type="numeric"
                  onChange={onChange}
                  name="ShareHolderParticipationPercentage"
                />
              </CustomFormInput>
            )}
            {newShareHolder.ShareHolderPersonType === "Physical" && (
              <React.Fragment>
                <div>
                  <CheckFormField
                    label="Has a web account?"
                    initialValue={newShareHolder.ShareHolderHasWebAccount}
                    value={newShareHolder.ShareHolderHasWebAccount}
                    onChange={onChange}
                    name="ShareHolderHasWebAccount"
                  />
                </div>
                {newShareHolder.ShareHolderHasWebAccount && (
                  <div>
                    <CheckFormField
                      label="Is Read Only?"
                      initialValue={newShareHolder.ShareHolderIsReadOnly}
                      value={newShareHolder.ShareHolderIsReadOnly}
                      onChange={onChange}
                      name="ShareHolderIsReadOnly"
                    />
                  </div>
                )}
              </React.Fragment>
            )}
          </Form>
        </ModalBody>
        {userSession.IsReadOnly === false && (
          <ModalFooter>
            <LaddaButton
              className="btn btn-ladda btn-primary"
              loading={loading}
              disabled={preCheckPercentage()}
              onClick={() => saveShareHolder(newShareHolder)}
              data-style={EXPAND_RIGHT}
            >
              Save
            </LaddaButton>{" "}
            <Button color="secondary" onClick={onToggle}>
              Cancel
            </Button>
          </ModalFooter>
        )}
      </Modal>
    </div>
  );
};

ModalShareHolder.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  initialShareHolder: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  shareHolders: PropTypes.array.isRequired,
  personId: PropTypes.string.isRequired,
  services: PropTypes.object.isRequired,
  headerText: PropTypes.string,
};

export default ModalShareHolder;
